import cx from "classnames";

import { useHaptics } from "../../modules/haptics/useHaptics/useHaptics";

interface CheckboxProps {
  checked?: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
  subtitle?: string;
  disabled?: boolean;
  invalid?: boolean;
  textStyle?: "text-body2" | "text-bold2" | "text-body3";
  /** Extra classes for the checkbox input (e.g. to override the default margin). */
  inputClassName?: string;
  /** Extra classes for the label text (e.g. to override the default font size). */
  labelClassName?: string;
}

export const Checkbox = ({
  label,
  subtitle,
  checked,
  onChange,
  disabled = false,
  invalid = false,
  textStyle = "text-body2",
  inputClassName,
  labelClassName,
}: CheckboxProps) => {
  const { triggerHaptic } = useHaptics();
  // A native <label> wrapping the input associates the two implicitly, so the checkbox
  // gets an accessible name from the label text and the whole control toggles on click —
  // no wrapper role="button"/tabIndex needed at the call site.
  return (
    <label className="flex cursor-pointer items-center">
      <input
        type="checkbox"
        aria-invalid={invalid}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          void triggerHaptic("checkbox").catch(() => undefined);
          onChange?.(e.target.checked);
        }}
        className={cx(
          "m-2.5 h-6 w-6 cursor-pointer rounded border border-solid border-dark-grey bg-white text-brand-color ring-0 ring-transparent focus:ring-0 focus:ring-transparent aria-invalid:ring-1 aria-invalid:ring-red aria-invalid:placeholder:text-red",
          disabled && "cursor-not-allowed opacity-30",
          inputClassName,
        )}
      />
      <div className="ml-1.5 flex flex-col gap-0.5 text-left">
        {label && (
          <div
            className={cx(
              `${textStyle} `,
              invalid && "text-red",
              disabled ? "text-secondary" : "text-primary",
              labelClassName,
            )}
          >
            {label}
          </div>
        )}
        {subtitle && <div className="text-body2 text-secondary">{subtitle}</div>}
      </div>
    </label>
  );
};
